import styled from '@emotion/styled';

const MDXStyledH1 = styled.h1`
  margin: 2rem 0 3px;
  font-size: 1.85rem;
  font-weight: 600;
`;

export default MDXStyledH1;
